<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox filter">
      <div class="row">
        <div
          class="col-lg-7 col-md-6 align-middle"
          style="
            justify-content: space-between;
            transition: max-width 0.5s ease;
          "
        >
          <h2 class="page-title">Plan Alokasi Muat</h2>
        </div>
        <div class="col-lg-2 col-md-6">
          <MultiSelect
            v-model="filter.region"
            :options="options.region"
            :deselect-label="''"
            placeholder="All Regions"
            class="tms-multiselect"
          />
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="input-group">
            <flat-pickr
              :config="rangePickr"
              placeholder="Select Date"
              v-model="selected.date"
            ></flat-pickr>
            <div class="input-group-append">
              <span
                class="input-group-text bg-white border-left-0"
                style="
                  border-top-right-radius: 5px;
                  border-bottom-right-radius: 5px;
                  border: 0;
                  box-shadow: 0 0 6px #0000000f;
                  background-color: #ededed !important;
                "
              >
                <i class="fas fa-calendar" style="color: black"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <!-- Chart Start -->
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="innerBox mt-4">
          <h5 style="font-size: 20px; color: #4d4d4d; font-weight: 600">
            Plant Distribution
          </h5>
          <plan-alokasi-chart :data="data"></plan-alokasi-chart>
        </div>
      </div>
    </div>
    <!-- Chart End -->
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import debounce from "debounce";
import planAlokasiChart from "./children/PlanAlokasiChart";

export default {
  metaInfo: {
    title: "Plan Alokasi Muat",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");

    return {
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: "form-control input grey-flatpickr",
      },
      options: {
        region: this.$store.getters.getRegion,
      },
      selected: {
        date: `${startDate} to ${currentDate}`,
      },
      filter: {
        region: null,
        start: startDate,
        end: currentDate,
      },

      data: null,
    };
  },
  components: {
    planAlokasiChart,
  },
  watch: {
    filter: {
      deep: true,
      immediate: true,
      handler: "delayedFetchData",
    },
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];
    },
  },
  methods: {
    delayedFetchData: debounce(function () {
      this.fetchData();
    }, 1000),
    fetchData() {
      if (this.filter === 'All') {
        this.filter = {...this.filter, region: null};
      }
      this.$http
        .get(
          `/api/plan-alokasi/report-by-plant?${qs.stringify(this.filter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data = resp.data.data;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 10px 20px;
}

.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}
</style>
